<template>
    <div class="w-full">
            <vs-button color="success" icon-pack="feather" icon="icon-user-plus" type="filled" @click="open">
            {{  $t('add') | capitalize }}    
            </vs-button>
        <vs-popup-custom :title="$t('vendor') | capitalize" color="danger" :buttonCloseHidden="true"
            :active.sync="active" :persistent="true">
            <div id="add-vendor-loading" class="vs-con-loading__container">
                <div class="px-2">
                    
                    <vs-row class="mt-2">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <span>{{ $t('vendor') | capitalize }}</span>
                        </vs-col>
                    </vs-row>
                    <vs-row class="mt-2">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <v-select label="name" :filterable="false" :options="vendors" @search="onSearchVendors"
                                class="w-full" v-model="vendor">
                            </v-select>
                        </vs-col>
                    </vs-row>
                    <vs-row class="mt-2">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <span>{{ $t('status') | capitalize }}</span>
                        </vs-col>
                    </vs-row>
                    <vs-row class="mt-2">
                        <vs-col vs-xs="4" vs-sm="2" vs-lg="2">
                            <vs-switch color="success" v-model="status" class="w-full">
                                <span slot="on">{{ $t('active') | capitalize }}</span>
                                <span slot="off">{{ $t('disabled') | capitalize }}</span>
                            </vs-switch>
                        </vs-col>
                    </vs-row>

                    <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="3" vs-lg="3">
                            <vs-button class="w-full mx-2" type="border" @click="close">
                                {{ $t('cancel') | capitalize }}
                            </vs-button>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="3" vs-lg="3">
                            <vs-button class="w-full mx-2" type="filled" color="primary" :disabled="disabledSubmit"
                                @click="handleSubmit">
                                {{ $t('save') | capitalize }}
                            </vs-button>
                        </vs-col>
                    </vs-row>
                </div>
            </div>
        </vs-popup-custom>
    </div>
</template>

<script>
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
import loading from '@/mixins/Loading'
import vSelect from 'vue-select'
import request from '../request'
import debounce from 'lodash/debounce'

export default {
    components: {
        VsPopupCustom,
        'v-select': vSelect,
    },
    computed: {
        disabledSubmit() {
            return this.rfc === '' || this.name === '' || this.email === ''
        },
    },
    data() {
        return {
            active: false,
            vendors: [],
            vendor: null,
            status: false
        }
    },
    methods: {
        open() {
            this.vendors = [],
                this.vendor = null,
                this.status = false,
                this.active = true
        },
        close() {
            this.active = false
        },
        onSearchVendors(search, loading) {
            if (search.length > 3) {
                loading(true);
                this.getVendors(loading, search, this);
            }
        },
        getVendors: debounce((loading, search, vm) => {
            request
                .search({ search: search })
                .then((res) => {
                    vm.vendors = [...res.data.vendors]
                    loading(false);
                })
                .catch((err) => {
                    vm.vendors = []
                    loading(false);
                })
        }),
        handleSubmit() {
            const payload = {
                vendor: this.vendor.id,
                status: this.status
            }
            console.log(payload)
            this.openLoading('add-vendor-loading')
            request
                .addVendor(payload)
                .then((res) => {
                    this.closeLoading('add-vendor-loading')
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Vendor Saved',
                    })
                    this.close()
                    this.$emit('success', res.data.item)
                })
                .catch((res) => {
                    this.showValidationErrors(res)
                    this.closeLoading('add-vendor-loading')
                })
        },
    },
    mixins: [loading],
}
</script>

<style>
.popup-custom-h-400 {
    height: 290px;
}

.vs__dropdown-menu {
    max-height: 50px;
}
</style>